import React, { useState } from 'react';
import Product from '../Product';
import {ProductGroup, NeuroMessage, ProductPagePropTypes, usePages, contact} from '@ignitesales/neuro-application/src/neuro-guide';
import { AnswersList } from '@ignitesales/neuro-application/src/neuro-guide/guide-framework';
import ContactFormModal from '../modals/ContactFormModal';
import SuccessFormModal from '../modals/SuccessFormModal';
import ShareViaSmsModal from '@ignitesales/neuro-application/src/neuro-guide/components/ShareViaSmsModal';
import ShareViaEmailModal from '@ignitesales/neuro-application/src/neuro-guide/components/ShareViaEmailModal';
import PrintButton from '@ignitesales/neuro-application/src/neuro-guide/components/PrintButton';
import { useUser, useAnswers } from '@ignitesales/neuro-application/src/neuro-guide/hooks';


function DetailsPage({ componentClass, product, productGroups }) {
  const { goToPreviousPage } = usePages();
  const { hasAnswer } = useAnswers();
  const { uuid } = useUser();
  const [ showContactFormModal, setShowContactFormModal ] = useState(false);
  const [ showShareViaSmsModal, setShowShareViaSmsModal ] = useState(false);
  const [ showShareViaEmailModal, setShowShareViaEmailModal ] = useState(false);
  const [ showSuccessFormModal, setShowSuccessFormModal ] = useState(false);
  const [ selectedProduct, setSelectedProduct ] = useState({});
  const [ leadTransmitted, setLeadTransmitted ] = useState(hasAnswer('leadTransmitted'));


  const renderProductGroup = (productGroup, subGroups, products) => {
    const cssBEM = 'product-group';

    return products.length ?
      <div className={cssBEM} key={ productGroup.name }>
        <div className={ `${ cssBEM }__container` } key={ productGroup.name }>
          <div className={ `${ cssBEM }__header count-${ products.length || 0 }` }>
            <h1><NeuroMessage id={ `productGroup.${ productGroup.name }` } tagName="span"/></h1>
          </div>
          { subGroups || null }
          { products || null }
        </div>
      </div> : null;
  };

  const openProductUrl = () => window.open( selectedProduct.productUrl,  "_blank" );

  const onProductClick = (params) => {
    setSelectedProduct(params);

    if(leadTransmitted) {
      setShowSuccessFormModal(true);
    } else {
      setShowContactFormModal(true);
    }
  }

  const onContactSuccess = () => {
    setShowContactFormModal(false);
    setShowSuccessFormModal(true);
    setLeadTransmitted(true);
  }

  const onSuccessAction = () => {
    openProductUrl();
    setShowSuccessFormModal(false);
  }

  const renderProduct = (product) => {
    return <Product
      key={ product.id }
      product={ product }
      onClick={ onProductClick }
    />;
  };


  // add prop with selectedProduct
  const contactFormModal = (
    <ContactFormModal
      className={`${componentClass}__contactModal contactForm`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showContactFormModal}
      onClose={() => setShowContactFormModal(false)}
      onComplete={ onContactSuccess }
      selectedProduct= { selectedProduct }
    />
  );

  // add onClick to swap the product CTA text to 'selected'
  const successFormModal = (
    <SuccessFormModal
      className={ `${componentClass}__successFormModal` }
      closeBtn={ <i className={'fa fa-times'} /> }
      isOpen={ showSuccessFormModal }
      onClose={ () => setShowSuccessFormModal(false) }
      onSuccessModalClose={ onSuccessAction }
      selectedProduct= { selectedProduct }
    />
  );

  const shareViaSmsModal = (
    <ShareViaSmsModal
      className={`${componentClass}__smsModal shareModal`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaSmsModal}
      onClose={() => setShowShareViaSmsModal(false)}
    />
  );

  const shareViaEmailModal = (
    <ShareViaEmailModal
      className={`${componentClass}__emailModal shareModal`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaEmailModal}
      onClose={() => setShowShareViaEmailModal(false)}
    />
  );

  return (
    <div className={componentClass}>
      <div className={ `${ componentClass }__header` }>
        <NeuroMessage id="summary.header" tagName='h1' />
      </div>

      <div className={ `${ componentClass }__actionBar` }>
        <div className="guideInfo">
          <h4>Reference #{ uuid }</h4>
          <NeuroMessage id="summary.actionBar" tagName='p' values={{ uuid }} />
        </div>
        <div className="actions">
            <div className="sms action" onClick={() => { setShowShareViaSmsModal(true); }}>
              <span className="fa fa-mobile"/>
              <NeuroMessage id="summary.mobile" tagName='h5' />
            </div>

            <div className="email action" onClick={() => { setShowShareViaEmailModal(true); }}>
              <span className="fa fa-envelope"/>
              <NeuroMessage id="summary.email" tagName='h5' />
            </div>

            <PrintButton className="print action" tagName="div">
              <span className="fa fa-print"/>
              <NeuroMessage id="summary.print" tagName='h5' />
            </PrintButton>
        </div>
      </div>

      <div className={ `${ componentClass }__products` }>{ productGroups.map(g =>
        <ProductGroup group={ g } renderGroupFn={ renderProductGroup } renderProductFn={ renderProduct } key={ g.name } />
      )}
      </div>

      <div className={ `${ componentClass }__answers` }>
        <NeuroMessage id="summary.answers" tagName='h2' />
        <AnswersList />
      </div>

      <div className={ `${ componentClass }__navigation` }>
        <button onClick={goToPreviousPage} className="btn btn-secondary"><NeuroMessage id="nav.prev"/></button>
      </div>
      <div className={ `${ componentClass }__footer` }>
        <NeuroMessage id="summary.footer" tagName='p'/>
      </div>

      { contactFormModal }
      { shareViaSmsModal }
      { shareViaEmailModal }
      { successFormModal }

    </div>
  );
}

DetailsPage.propTypes = ProductPagePropTypes;

export default DetailsPage;
